//====================================================
//  Initialization Accordion
//====================================================
function fn_components_gallery(){
	if($('.open-gallery').length){
        
        $(document).on("click", ".gallery-block", function() {
            var $gallery_data = $(this).find('[data-gallery]').data('gallery');
            $(this).lightGallery({
                dynamic: true,
                actualSize: false,
                dynamicEl: $gallery_data
            });
        });
    }

}